import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';

// components
import PdpSharedDetailMeasurement from './helpers/PdpSharedDetailMeasurement';

// helpers
import get from 'lodash.get';

function PdpSharedDetailDiameter({ item }) {
    return (
        <PdpSharedDetailMeasurement
            dataTn="pdp-spec-diameter"
            measurements={get(item, 'measurement.diameter')}
        />
    );
}

PdpSharedDetailDiameter.propTypes = {
    item: PropTypes.object.isRequired,
};

export default createFragmentContainer(PdpSharedDetailDiameter, {
    item: graphql`
        fragment PdpSharedDetailDiameter_item on Item {
            measurement {
                diameter: display(fields: [diameter]) {
                    ...PdpSharedDetailMeasurement_measurements
                }
            }
        }
    `,
});
